import { AfterContentChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BooleanStrings } from '../../../../constants';
import { MenuService } from '../../../../services';
import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-checkbox-renderer',
  templateUrl: './checkbox-renderer.component.html',
  styleUrl: './checkbox-renderer.component.scss',
})
export class CheckboxRendererComponent
  extends BaseRendererComponent
  implements AfterContentChecked, ICellRendererAngularComp
{
  protected readonly menuService = inject(MenuService);
  private readonly cdRef = inject(ChangeDetectorRef);

  protected readonly BooleanStrings = BooleanStrings;

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  get isEditable(): boolean {
    return (this.params.colDef as any)?.editable(this.params as any) ?? false;
  }

  public onChange(event: any) {
    const checked = event.target.checked;
    const colId = this.params.column.getColId();
    this.params.node.setDataValue(colId, checked);
    if (event.currentTarget.checked) {
      this.params.node.setSelected(true);
    }
  }
}
